import { Component } from 'react';

class PromptsView extends Component {
    constructor(props) {
        super(props);

        this.selectAll = this.selectAll.bind(this);

        this.promptKey = props.promptKey ?? 'prompts';
        this.state = {
            searchValues: '',
            prompts: props.item[this.promptKey] ?? [],
        };
    }

    componentDidUpdate(prevProps) {
        if (
            JSON.stringify(prevProps.item[this.promptKey]) !==
            JSON.stringify(this.props.item[this.promptKey])
        ) {
            this.setState({ prompts: this.props.item[this.promptKey] ?? [] });
        }
    }

    /**
     * The prompts this view can actually act on.
     *
     * A prompt the project already tracks is shown ticked and locked, so it is not part of
     * "select all" -- sweeping it in would hand the caller a prompt it is about to submit for
     * tracking a second time, and would leave the header checkbox permanently unticked because
     * a locked row can never enter the selection.
     */
    selectablePrompts() {
        return (this.state.prompts ?? [])
            .map((prompt) => prompt?.text ?? prompt)
            .filter((text) => !this.props.disabledPrompts?.includes(text));
    }

    selectAll() {
        this.props.onSelectAllPrompts(this.selectablePrompts());
    }

    render() {
        const {
            item,
            uniqueKey,
            showOpened,
            onClickOnStep,
            onSelectPrompts,
            headerKey,
            selectedItems,
        } = this.props;

        const selectable = this.selectablePrompts();

        return (
            <div className="prompt-generator-step-box">
                <div
                    className={`purchase-container-item-header ${showOpened(
                        `${uniqueKey}`,
                        'show',
                    )}`}
                    onClick={() => onClickOnStep(`${uniqueKey}`)}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        {item[headerKey]}
                        {!this.props.hideCollapse && (
                            <button className="arrow-icon">
                                <i className="icon-chevron-right" />
                            </button>
                        )}
                    </div>
                    {item?.description && (
                        <div className="purchase-container-item-subheader">{item?.description}</div>
                    )}
                </div>
                <div
                    className={`purchase-container-item-body ${showOpened(`${uniqueKey}`, 'show')}`}
                >
                    <div className="prompt-generator-step-box-body">
                        <div className="d-flex align-items-center justify-content-between mb-10 w-100">
                            <div className="gap-10 d-flex align-items-center w-100">
                                <input
                                    id={'select-all'}
                                    type="checkbox"
                                    onChange={this.selectAll}
                                    checked={
                                        selectable.length > 0 &&
                                        selectable.every((text) => selectedItems.includes(text))
                                    }
                                />
                                <label htmlFor={'select-all'}>Select All</label>
                            </div>
                        </div>
                    </div>
                    <div className="prompt-generator-step-box-body">
                        {this.state.prompts.map((prompt, idx) => {
                            let text = prompt?.text ?? prompt;
                            let id = prompt?.id ?? `${uniqueKey}-${idx}`;

                            // A prompt the project already tracks is ticked and locked: it is
                            // in the project, which is what the tick says, and there is nothing
                            // to decide about it. The greyed label keeps it apart from a row the
                            // user has just picked.
                            const isTracked = !!this.props.disabledPrompts?.includes(
                                text?.toLowerCase(),
                            );

                            return (
                                <div
                                    key={`${idx}-${text}`}
                                    className="gap-10 d-flex align-items-center"
                                >
                                    <input
                                        id={id}
                                        type="checkbox"
                                        onChange={() => onSelectPrompts(text)}
                                        checked={isTracked || selectedItems.includes(text)}
                                        disabled={isTracked}
                                    />
                                    <label
                                        htmlFor={id}
                                        className={isTracked ? 'disabled-item' : ''}
                                    >
                                        {text}
                                    </label>
                                </div>
                            );
                        })}
                        {this.state.prompts.length === 0 && <div className="mt-10">No Prompts</div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default PromptsView;
